import React, { useState } from "react";

import { useViewport } from "@/contexts/ViewportContext";
import { useAppNavigation } from "@/hooks/application/navigation";
import { useAppSelector } from "@/hooks/application/store";
import { useLogout } from "@/hooks/domain/auth";
import { RootNavigation } from "@/navigation/Root";

import SettingsMobile from "./Settings.mobile";
import SettingsWeb from "./Settings.web";
import TermsModal from "./components/TermsModal";
import { SettingsModalTypes } from "./options";
import { SettingsProps } from "./types";

const Settings = () => {
  const { isWebMode } = useViewport();

  const { navigate, navigateBetweenStacks } = useAppNavigation<RootNavigation>();
  const { user } = useAppSelector((store) => store.auth);
  const { logout } = useLogout();

  const [termsModalVisible, setTermsModalVisible] = useState(false);

  const onOptionPress: SettingsProps["onOptionPress"] = ({ route, stack, isModal, modalType }) => {
    if (stack) {
      if (route) {
        return navigateBetweenStacks(stack, route);
      }
      return navigateBetweenStacks(stack);
    }
    if (isModal) {
      switch (modalType) {
        case SettingsModalTypes.TERMS:
          return setTermsModalVisible(true);
        default:
          return null;
      }
    }
  };

  const onBackPress = () => navigate("homeStack");

  const onPressLogout = () => {
    logout();
  };

  const Screen = isWebMode ? SettingsWeb : SettingsMobile;

  return (
    <>
      <Screen
        userName={user?.cliente?.nome}
        onOptionPress={onOptionPress}
        onBackPress={onBackPress}
        onPressLogout={onPressLogout}
      />
      <TermsModal isOpen={termsModalVisible} onClose={() => setTermsModalVisible(false)} />
    </>
  );
};

export default Settings;
